import MessagingInternalService from './services';
import MessagingInternalTypes from './types';

export const getMessages = (pagination?: any) =>
  MessagingInternalTypes.getMessages.createAction(() => MessagingInternalService.getMessages(pagination));
export const getChats = () => MessagingInternalTypes.getChats.createAction(() => MessagingInternalService.getChats());
export const getMessagesChat = (id: number) =>
  MessagingInternalTypes.getMessagesChat.createAction(() => MessagingInternalService.getMessagesChat(id));
export const sendMessageChat = (id: number, content: string, sendEmail: boolean) =>
  MessagingInternalTypes.sendMessageChat.createAction(() => MessagingInternalService.sendMessageChat(id, content, sendEmail));
export const listProducts = () => MessagingInternalTypes.listProducts.createAction(() => MessagingInternalService.listProducts());
export const getAffiliates = (products: any) =>
  MessagingInternalTypes.getAffiliates.createAction(() => MessagingInternalService.getAffiliates(products));
export const sendMessageBroadcast = (content: string, customers: any, sendEmail: boolean) =>
  MessagingInternalTypes.sendMessageBroadcast.createAction(() => MessagingInternalService.sendMessageBroadcast(content, customers, sendEmail));
